import { TR, TDT, TA, TD } from "../../components";
import { FaRegEdit, FaEye } from "react-icons/fa";
import { FiEdit2 } from "react-icons/fi";
import { RiDeleteBin5Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import TableContext from "../Provider/TableContext";
import { convDateTime4 } from "../../../../Util/Time";
import { IoMdOpen } from "react-icons/io";

function TableRow(props) {
  const { doc } = props;
  const navigate = useNavigate();
  const { setShowDeleteModal, setSystemId, systemId } =
    useContext(TableContext);

  function showDelete() {
    setSystemId(doc?.id);
    setShowDeleteModal(true);
  }

  return (
    <TR>
      <TDT
        name="Trip"
        txt={`${doc?.dispatch_scheduling?.departure_point ?? "--"}-${
          doc?.dispatch_scheduling?.destination ?? "--"
        }`}
      />

      <TDT name="Fuel Date" txt={convDateTime4(doc?.fuel_date) || ""} />
      <TDT name="Cost" txt={doc?.cost || "--"} />
      <TDT name="Price Per Litre" txt={doc?.price_per_litre || "--"} />
      <TDT name="Fuel Amount" txt={doc?.fuel_amount || "--"} />
      <TDT name="Filling Station" txt={doc?.filling_station || "--"} />
      <TDT
        name="Receipt"
        txt={
          doc?.nano_receipt
            ? (() => {
                // Extract file extension from URL
                const ext = doc.nano_receipt.split(".").pop().toLowerCase();

                // Check if it's a PDF
                const isPdf = ext === "pdf";

                return (
                  <a
                    href={doc.nano_receipt}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-blue-600 hover:underline"
                    {...(isPdf ? { download: true } : {})}
                  >
                    <IoMdOpen className="text-lg" />
                    {isPdf ? "Download Receipt" : "Open Receipt"}
                  </a>
                );
              })()
            : "--"
        }
      />
      {/* <TDT
        name="ACTION"
        txt={
          <div className="flex gap-4">
            <div className="cursor-pointer">
              <p
                className="text-center flex gap-2"
                onClick={() => navigate(`view/${doc?.id}`)}
              >
                <FaEye className="text-blue-500 text-2xl text-center" />
              </p>
            </div>
            <div className="cursor-pointer">
              <p
                className="text-center flex gap-2"
                onClick={() => navigate(`edit/${doc?.id}`)}
              >
                <FiEdit2 className="text-2xl text-center" />
              </p>
            </div>
            <div onClick={() => {}} className="cursor-pointer">
              <p className="text-center flex gap-2">
                <RiDeleteBin5Line
                  className="text-red text-2xl text-center cursor-pointer"
                  onClick={showDelete}
                />
              </p>
            </div>
          </div>
        }
      /> */}
    </TR>
  );
}

export default TableRow;
